import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { SerpixWordmark } from "../brand/SerpixWordmark";
import { Twitter, Github, Linkedin } from "lucide-react";

export function LandingFooter() {
  const { t } = useTranslation();

  const cols = [
    {
      title: t("landing.footer.product"),
      links: [
        { label: t("landing.footer.features"), href: "#features" },
        { label: t("landing.footer.pricing"), href: "#pricing" },
        { label: t("landing.footer.changelog"), href: "#" },
        { label: t("landing.footer.roadmap"), href: "#" },
      ],
    },
    {
      title: t("landing.footer.resources"),
      links: [
        { label: t("landing.footer.docs"), href: "#" },
        { label: t("landing.footer.blog"), href: "#" },
        { label: t("landing.footer.support"), href: "#" },
        { label: "FAQ", href: "#faq" },
      ],
    },
    {
      title: t("landing.footer.company"),
      links: [
        { label: t("landing.footer.about"), href: "#" },
        { label: t("landing.footer.careers"), href: "#" },
        { label: t("landing.footer.contact"), href: "mailto:hello@serpix.co" },
      ],
    },
    {
      title: t("landing.footer.legal"),
      links: [
        { label: t("landing.footer.privacy"), href: "#" },
        { label: t("landing.footer.terms"), href: "#" },
      ],
    },
  ];

  return (
    <footer
      className="border-t border-zinc-200 bg-white"
      data-testid="landing-footer"
    >
      <div className="mx-auto max-w-7xl px-6 py-16 lg:px-8">
        <div className="grid grid-cols-2 gap-10 md:grid-cols-6">
          <div className="col-span-2">
            <SerpixWordmark size="md" />
            <p className="mt-4 max-w-xs text-sm text-zinc-500">
              {t("landing.footer.tagline")}
            </p>
            <div className="mt-5 flex items-center gap-2">
              {[Twitter, Github, Linkedin].map((I, i) => (
                <a
                  key={i}
                  href="#"
                  className="flex h-9 w-9 items-center justify-center rounded-full border border-zinc-200 text-zinc-500 transition-colors hover:border-violet-300 hover:bg-violet-50 hover:text-violet-700"
                >
                  <I className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>
          {cols.map((c) => (
            <div key={c.title}>
              <div className="mb-4 text-xs font-semibold uppercase tracking-wider text-zinc-500">
                {c.title}
              </div>
              <ul className="space-y-2">
                {c.links.map((l) => (
                  <li key={l.label}>
                    {l.href.startsWith("http") || l.href.startsWith("mailto") || l.href.startsWith("#") ? (
                      <a
                        href={l.href}
                        className="text-sm text-zinc-700 transition-colors hover:text-violet-700"
                      >
                        {l.label}
                      </a>
                    ) : (
                      <Link
                        to={l.href}
                        className="text-sm text-zinc-700 transition-colors hover:text-violet-700"
                      >
                        {l.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-3 border-t border-zinc-100 pt-6 text-xs text-zinc-500 md:flex-row md:items-center">
          <div>
            © {new Date().getFullYear()} Serpix · serpix.co · {t("landing.footer.rights")}
          </div>
          <div>Made with ♥ in Istanbul</div>
        </div>
      </div>
    </footer>
  );
}
